export default __webpack_public_path__ + "static/media/houstonTexans@2x.72afe492.jpg";